import React, { Dispatch, SetStateAction, useMemo } from 'react'

import dayjs from 'dayjs'
import { BsCopy } from 'react-icons/bs'
import { PiTrashLight } from 'react-icons/pi'

import { Button, SectionSubtitle } from '../../../../..'
import { useProfessors, useStudents, useUser } from '../../../../../../context'
import { useWindowSize } from '../../../../../../hooks/useWindowSize'
import { NewLog } from '../../../../../../types'
import { filterProfessor } from '../../../../../../utilFunctions'
import { Divider, Spacer } from '../../../../../global'
import {
  LogsRow,
  MarksContainer,
  TableContainer,
} from '../../../../../lists/styles'
import { getLatestLog, getValidLogs } from '../logSelectors'

const LastLog = ({
  setLog,
  handleCopyLog,
  handleDelete,
}: {
  setLog: Dispatch<SetStateAction<NewLog | null>>
  handleCopyLog: (logItem: NewLog) => void
  handleDelete: (
    studentUID: string,
    logUID: string,
    professorUID: string,
  ) => void
}) => {
  const { studentLogs, activeStudent } = useStudents()
  const { professorsList } = useProfessors()
  const { user } = useUser()
  const { isMobile } = useWindowSize()

  const lastLog = useMemo(() => getLatestLog(studentLogs), [studentLogs])
  const validLogCount = useMemo(
    () => getValidLogs(studentLogs).length,
    [studentLogs],
  )

  const handleDeleteLog = async (professorUID: string, logUID?: string) => {
    if (logUID && activeStudent) {
      handleDelete(activeStudent.uid, logUID, professorUID)
    }
  }

  return (
    <TableContainer>
      <MarksContainer>
        <SectionSubtitle fontSize={16} fontWeight={500}>
          {lastLog
            ? 'Última bitácora cargada'
            : 'El alumno aún no tiene ninguna bitácora cargada'}
        </SectionSubtitle>
      </MarksContainer>
      <Spacer height={15} />
      <Divider />
      <Spacer height={15} />
      {studentLogs && lastLog && (
        <LogsRow>
          <div className="l-log-number">Bitácora N {validLogCount}</div>
          <div className="l-red">
            Cargada el {dayjs(lastLog.date).format('DD/MM/YYYY')}
          </div>
          <div className="l-student with-image">
            <div
              className="profile-image"
              style={{
                backgroundImage: `url(${filterProfessor(lastLog.professorUID, professorsList, true) ? filterProfessor(lastLog.professorUID, professorsList, true) : '/assets/profile.png'})`,
              }}
            ></div>
            <span className="l-yellow">Profesor: </span>
            <span style={{ textTransform: 'capitalize', marginLeft: '5px' }}>
              {filterProfessor(lastLog.professorUID, professorsList)}
            </span>
          </div>
          <div className="l-actions">
            <Button
              label={`Ver ${!isMobile ? 'bitácora' : ''}`}
              onClick={() => setLog(lastLog)}
              className="dark-grey btn-open-log"
            />

            <button
              type="button"
              onClick={() => handleCopyLog(lastLog)}
              className="btn-copy-log"
            >
              <BsCopy />
            </button>

            {user?.uid === lastLog.professorUID && (
              <button
                type="button"
                onClick={() =>
                  handleDeleteLog(lastLog.professorUID, lastLog.uid)
                }
                className="btn-delete-log"
                aria-label="Eliminar última bitácora"
              >
                <PiTrashLight aria-hidden="true" />
              </button>
            )}
          </div>
        </LogsRow>
      )}
    </TableContainer>
  )
}

export default LastLog
